import React from 'react';
import { Link } from 'react-router-dom';
import WorkbookBadge from '../Badges/WorkbookBadge';
import maybe from '../@common/enhancers/maybe';
import { remCalc } from '../../util/style-util';
import { BadgeType } from 'types';
import { white } from '../../styles/style-constants';
import { FONT_GSS_FUTURA } from 'themes/default';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

type Props = {
  workbook: any;
  routeTo: string;
  handleWorkbookClick?: () => void;
  styles: any;
  renderWorkbookBadge: boolean;
  badgeType: BadgeType | null;
  gradeLevelDescription: string;
  onWorkbookClick?: any;
};

const MaybeWorkbookBadge: any = maybe(WorkbookBadge);

const WorkbooksMenuItem = ({
  workbook,
  onWorkbookClick,
  routeTo,
  styles: styleOverrides,
  renderWorkbookBadge,
  badgeType,
  gradeLevelDescription
}: Props) => {
  const handleWorkbookClick = () => {
    onWorkbookClick(workbook);
  };

  const classes = useStyles();

  return (
    <li
      className={clsx(classes.workbookItem, styleOverrides.workbookItem)}
      onClick={handleWorkbookClick}
    >
      <Link className={clsx(classes.workbookLink)} to={routeTo}>
        <div style={{ position: 'relative' }}>
          <img
            className={clsx(classes.workbookImage, styleOverrides.workbookImage)}
            src={workbook.combinedCoverImageUrl}
            alt={`${workbook.title} Icon`}
          />
          <MaybeWorkbookBadge
            shouldRender={renderWorkbookBadge}
            badgeType={badgeType}
            styles={{ badge: classes.badge }}
          />
        </div>
        <span className={clsx(classes.workbookTitle, styleOverrides.workbookTitle)}>
          {workbook.title}
        </span>
        <span className={clsx(classes.gradeLevelDescription, styleOverrides.gradeLevelDescription)}>
          {gradeLevelDescription}
        </span>
      </Link>
    </li>
  );
};

const useStyles = makeStyles(() => ({
  workbookItem: {
    textAlign: 'center',
    padding: `${remCalc(10)} ${remCalc(12)}`
  },
  workbookImage: {
    width: '90%',
    marginTop: remCalc(14),
    marginBottom: remCalc(12)
  },
  workbookTitle: {
    display: 'inline-block',
    fontFamily: FONT_GSS_FUTURA,
    fontWeight: 300,
    fontSize: remCalc(16),
    color: white
  },
  workbookLink: {
    display: 'flex',
    flexFlow: 'column nowrap',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'none'
    }
  },
  badge: {
    bottom: 0,
    right: 0
  },
  gradeLevelDescription: {
    fontFamily: FONT_GSS_FUTURA,
    fontWeight: 300,
    fontSize: remCalc(12),
    color: white,
    display: 'inline-block',
    padding: `0 ${remCalc(6)} 0 ${remCalc(6)}`
  }
}));

export default WorkbooksMenuItem;
